function formatSpecificationValue(value) {
  if (Array.isArray(value)) return value.join(', ');
  if (value && typeof value === 'object') {
    return Object.entries(value)
      .map(([key, nestedValue]) => `${key}: ${formatSpecificationValue(nestedValue)}`)
      .join(', ');
  }
  return String(value ?? '');
}

export function getSpecificationEntries(specifications) {
  let parsed = specifications;

  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      return [];
    }
  }

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return [];

  return Object.entries(parsed)
    .filter(([key, value]) => key !== 'source_path' && value !== '' && value != null)
    .map(([key, value]) => [key, formatSpecificationValue(value)]);
}
